export const MINT_COMPONENT_HEADING_SUBTEXT = {
  FIXED: {
    heading: 'Fixed Edition',
  },
  OPEN: {
    heading: 'Open Edition',
  },
  SAM: {
    heading: 'Sound Swap',
  },
  FREE: {
    heading: 'Free Edition',
    description: 'Prove you were here first',
  },
  PRESAVE: {
    heading: 'Early Listen',
    description: 'Pre-save to listen early',
  },
  FALLBACK: {
    heading: 'Limited Edition',
    description: 'Rare editions for collectors',
  },
} as const satisfies Record<Uppercase<string>, { heading: string; description?: string }>;
